
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Send, ArrowRight } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import LoadingSpinner from '@/components/shared/LoadingSpinner';

interface SubmissionButtonProps {
  isSubmitting?: boolean;
}

const SubmissionButton: React.FC<SubmissionButtonProps> = ({
  isSubmitting = false
}) => {
  const isMobile = useIsMobile();
  
  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6, duration: 0.5 }}
      className="relative mt-8"
    >
      {/* Decorative background pulse effect */}
      <div className="absolute -inset-1 bg-gradient-to-r from-green-400 to-emerald-500 rounded-lg blur-sm opacity-70 animate-pulse"></div>
      
      <Button 
        type="submit" 
        disabled={isSubmitting}
        className={`
          w-full relative z-10
          ${isMobile ? 'h-12 text-base' : 'h-14 text-lg'}
          bg-gradient-to-r from-green-500 to-emerald-500 
          hover:from-green-600 hover:to-emerald-600 
          transition-all font-medium
          border border-green-400 shadow-lg
          flex items-center justify-center gap-2
          disabled:opacity-80 disabled:cursor-not-allowed
          group
        `}
      >
        {isSubmitting ? (
          <>
            <LoadingSpinner size="sm" color="white" />
            <span>Đang xử lý...</span>
          </>
        ) : (
          <>
            <Send 
              className={`
                ${isMobile ? 'w-4 h-4' : 'w-5 h-5'} 
                group-hover:translate-x-1 transition-transform duration-300
              `} 
            />
            <span>Đăng ký tham dự</span>
            <ArrowRight 
              className={`
                ${isMobile ? 'w-4 h-4' : 'w-5 h-5'} 
                group-hover:translate-x-1 transition-transform duration-300
              `} 
            />
          </>
        )}
      </Button>
    </motion.div>
  );
};

export default SubmissionButton;
